module.exports = __webpack_public_path__ + "img/art_home_02.29534aac.png";